export default "__VITE_ASSET__Ck1yuVCC__"